import OIGSAMPage from "./OIGSAMPage";

export default OIGSAMPage;